import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import ReactDOM from 'react-dom';

const DocumentHead = ({
  children
}) => {
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsx(Fragment, {
    children: children
  }), document.head);
};

export default DocumentHead;